import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Navbar from "@/components/Navbar";
import { useAuth, API } from "@/context/AuthContext";
import { toast } from "sonner";

export default function BuyerProfile() {
  const { user } = useAuth();
  const [form, setForm] = useState({
    niche: "",
    sub_category: "",
    business_model: "",
    phone: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/users/me/contact`);
        setForm((prev) => ({ ...prev, phone: data?.phone || "" }));
      } catch {
        // Leave phone empty if contact endpoint is unavailable.
      }
    })();
  }, []);

  const onSave = async (event) => {
    event.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API}/users/me/profile`, {
        niche: form.niche,
        sub_category: form.sub_category,
        business_model: form.business_model,
        phone: form.phone,
      });
      toast.success("Buyer profile saved");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Unable to save buyer profile");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-bone">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
        <Link to="/dashboard" className="font-mono text-xs underline mb-8 block">← BACK TO DASHBOARD</Link>
        <div className="overline mb-3">§ BUYER PROFILE</div>
        <h1 className="font-serif text-5xl lg:text-6xl font-light leading-none tracking-tight">
          Your <em className="text-klein not-italic">Business</em> Snapshot
        </h1>
        <p className="text-sm text-[--muted-foreground] mt-4">
          This information helps us shape better RFQ matches and improve manufacturer responses.
        </p>

        <form onSubmit={onSave} className="editorial-card p-8 mt-8 space-y-6" data-testid="buyer-profile-form">
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="text-sm text-[--muted-foreground]">Name</label>
              <input value={user?.name || ""} disabled className="input-underline opacity-70" />
            </div>
            <div>
              <label className="text-sm text-[--muted-foreground]">Email</label>
              <input value={user?.email || ""} disabled className="input-underline opacity-70" />
            </div>
          </div>

          <div>
            <label className="text-sm">WhatsApp / phone number</label>
            <input
              className="input-underline mt-2"
              placeholder="e.g. +91 98765 43210"
              value={form.phone}
              onChange={(event) => setForm((prev) => ({ ...prev, phone: event.target.value }))}
              data-testid="buyer-profile-phone"
            />
          </div>

          <div>
            <label className="text-sm">Primary niche</label>
            <input
              className="input-underline mt-2"
              placeholder="e.g. Home Decor"
              value={form.niche}
              onChange={(event) => setForm((prev) => ({ ...prev, niche: event.target.value }))}
              data-testid="buyer-profile-niche"
            />
          </div>

          <div>
            <label className="text-sm">Sub-category focus</label>
            <input
              className="input-underline mt-2"
              placeholder="e.g. Ceramic tableware"
              value={form.sub_category}
              onChange={(event) => setForm((prev) => ({ ...prev, sub_category: event.target.value }))}
              data-testid="buyer-profile-sub-category"
            />
          </div>

          <div>
            <label className="text-sm">Business model</label>
            <textarea
              className="input-underline mt-2 min-h-[90px]"
              placeholder="Describe your brand model, channels, and volumes"
              value={form.business_model}
              onChange={(event) => setForm((prev) => ({ ...prev, business_model: event.target.value }))}
              data-testid="buyer-profile-business-model"
            />
          </div>

          <button className="btn-primary" disabled={saving} data-testid="buyer-profile-save">
            {saving ? "Saving..." : "Save profile"}
          </button>
        </form>
      </main>
    </div>
  );
}
